export default "__VITE_ASSET__CSKrnXtU__";